import { sequence } from '@angular/animations';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { ActivatedRoute, Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { GraphError } from '@microsoft/microsoft-graph-client/lib/src/GraphError';
import { TranslateService } from '@ngx-translate/core';
import { GraphService } from 'src/app/services/graph.service';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment';
import { ShowOnDirtyOrTouchedErrorStateMatcher } from '../../shared/show-on-dirty-or-touched-error-state-matcher';
import { ApproveDialogComponent } from '../../approve-dialog/approve-dialog.component';
import { DcnErrorComponent } from '../../dcn-error/dcn-error.component';
import { DcMaintainenceResponse } from '../../model/dc-maintainence-response';
import { Roles } from '../../model/roles';
import { SortableColumn } from '../../model/sort/sortable-column';
import { UserData } from '../../model/user-data';
import { UsersDataResponse } from '../../model/users-data-response';

@Component({
    selector: 'app-add-edit-dc-user',
    templateUrl: './add-edit-dc-user.component.html',
    styleUrls: ['./add-edit-dc-user.component.scss'],
    standalone: false
})
export class AddEditDcUserComponent implements OnInit {
  userAction: string = null;
  isDisabled: boolean = false;
  isHidden: boolean = false;
  user: UsersDataResponse;
  userData: UserData;
  dcUserForm: UntypedFormGroup;
  sortableColumn: SortableColumn;
  statusString: string;
  dcNumber: string;
  userRoles: Roles[] = [];
  provinces: string[] = [];
  selectedDcNumber: any;
  dcNumbers: DcMaintainenceResponse[];
  nameErrorMatcher = new ShowOnDirtyOrTouchedErrorStateMatcher();
  constructor(private router: Router, private userservice: UserService, private fb: UntypedFormBuilder, private route: ActivatedRoute,
    private dialog: MatDialog, private authService: MsalService, private graphService: GraphService,
    public translate: TranslateService) {
    translate.addLangs(['en', 'fr']);
    translate.setDefaultLang('en');
    this.createForm();
    this.statusString = 'Active'; //init val

    this.userservice.getCurrentUser().subscribe(data => {
      this.user = data;
      this.userData = data.userData;
      this.translate.use(this.userData.language.toLowerCase());
    })
    this.getProvinces();
  }


  ngOnInit() {
    this.route.queryParams
      .subscribe(params => {
        this.userAction = params['action'];
        this.dcNumber = params['dcNumber'];
        if (this.userAction === 'profile' || this.userAction === 'dc-user-edit') {

          if (this.userAction === 'profile') {
            this.dcUserForm.disable();

            this.dcUserForm.controls.language.enable();
            this.dcUserForm.controls.license.enable();
            this.dcUserForm.controls.firstName.enable();
            this.dcUserForm.controls.lastName.enable();
          }
          this.isDisabled = true;
          this.isHidden = false;

          this.route.params.subscribe(
            (params) => {

              let upn = params.upn;
              this.getUserDeailsBySeq(upn);
            })
        } else {
          if (this.userData.roleId === 1) {


            this.dcUserForm.controls.upn.enable();

            this.dcNumbers = this.user.dcLocations.filter(s => (s));
          } else {
            this.dcNumbers = this.user.dcLocations.filter(s => (s.roleId == 2));
          }

          this.roleAccessData();
        }
      }
      );
  }


  roleAccessData() {
    this.userRoles = [];
    if (this.userAction !== "profile") {
      this.user.lstAccess.forEach(e => {
        if (e.roleIdAccess < 4) {
          this.userRoles.push(e)
        }
      })
    } else

      if (this.userAction === "profile" && this.userData.roleId === 1) {


        let role = new Roles();
        role.roleIdAccess = 1
        role.roleName = "Super Admin"
        this.userRoles.push(role);

      } else

        if (this.userAction === "profile" && this.userData.roleId !== 1) {
              this.dcNumbers.forEach(e => {

            let role = new Roles();
            let index = this.userRoles.findIndex(s => s.roleIdAccess == e.roleId);
            if (index === -1) {
              role.roleIdAccess = e.roleId;
              if (e.roleId === 2) {
                role.roleName = "DC Admin";
              } else
                if (e.roleId === 3) {
                  role.roleName = "DC Coordinator";
                }

              this.userRoles.push(role);
            }
          })
        }
  }
  userView: UsersDataResponse;
  userDataView: UserData;
  getUserDeailsBySeq(sequenceNumber) {
    this.userRoles = [];
    this.userservice.getUserDataBySeq(sequenceNumber).subscribe(data => {
      this.userView = data;
      this.userDataView = data.userData;
     
      if (this.userAction === 'profile') {
      
        this.dcNumbers = this.user.dcLocations.filter(s => s);
      }
      else {
        if (this.userAction === 'dc-user-edit') {
          this.userservice.setObject("upn_value",this.userDataView.upn)
          if (this.userData.roleId === 1) {
            this.dcUserForm.controls.upn.enable();
          } else {
            this.dcUserForm.controls.upn.disable();
          }
          this.dcNumbers = this.userView.dcLocations.filter(s => s.dcNumber === parseInt(this.dcNumber));
        }


      }

      this.roleAccessData();

      this.dcUserForm.patchValue({
        firstName: this.trimmed(this.userDataView.firstName),
        lastName: this.trimmed(this.userDataView.lastName),
        intials: this.trimmed(this.userDataView.intials),
        license: this.userDataView.license,
        upn: this.userDataView.upn,
        dcLocation: this.userAction === 'profile' ? (this.dcNumbers[0].dcNumber) : this.userView.dcLocations.filter(d => d.dcNumber === parseInt(this.dcNumber))[0].dcNumber,
        province: this.userDataView.province,

        roleId: (this.userAction === 'profile' && this.user.userData.roleId === 1) ?

          1 :
          ((this.userAction === 'profile' && this.user.userData.roleId !== 1) ?
            this.dcNumbers[0].roleId :
            (this.dcNumbers.filter(s => s.dcNumber === parseInt(this.dcNumber)))[0].roleId),
        
        language: this.userDataView.language,
        userStatus: this.userAction === 'profile' ? this.dcNumbers[0].userDcStatus === 'Y' ? true : false : (this.userView.dcLocations.filter(s => s.dcNumber === parseInt(this.dcNumber))[0].userDcStatus === 'Y' ? true : false),

     
        sequenceNumber: this.userDataView.sequenceNumber


      });
      this.markNameFieldsTouched();

    })
  }

  private trimmed(value: string): string {
    return typeof value === 'string' ? value.trim() : value;
  }

  private trimNameFields(): void {
    ['firstName', 'lastName', 'intials'].forEach(name => {
      const control = this.dcUserForm.controls[name];
      if (typeof control?.value === 'string') {
        const trimmed = control.value.trim();
        if (trimmed !== control.value) {
          control.setValue(trimmed);
        }
      }
    });
  }

  private markNameFieldsTouched(): void {
    ['firstName', 'lastName', 'intials'].forEach(name => {
      this.dcUserForm.controls[name].markAsTouched();
    });
  }

  getRoleByDC(selectevent: MatSelectChange) {

    
    this.dcUserForm.controls.roleId.setValue(this.DCRole(selectevent.value).roleId);
  }

  DCRole(dcNumber) {
    let dc: DcMaintainenceResponse[] = null
    if (this.userAction === 'profile') {
      dc = this.user.dcLocations.filter(e => e.dcLocation === dcNumber);
    } else {

      dc = this.userView.dcLocations.filter(e => e.dcLocation === dcNumber);
    }

    return dc[0];


  }

  createForm() {
    this.dcUserForm = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      intials: [''],
      license: [''],
      upn: ['', Validators.required],
      dcLocation: ['', Validators.required],
      province: ['', Validators.required],
      roleId: ['', Validators.required],
      language: ['EN', Validators.required],
      userStatus: [true, Validators.required],
      sequenceNumber: [0]

    });

  }

  getProvinces() {
    this.userservice.getAllProvinces().subscribe(data => {
      this.provinces = data;
    })
  }

  setUserStatus(event: MatSlideToggleChange) {
    this.statusString = event.checked == true ? 'Active' : 'Inactive';
  }

  saveUser() {
    this.trimNameFields();

    if (this.userAction == 'dc-user-add') {
    
        this.validateUser(this.dcUserForm.controls.upn.value);
     } else
      if (this.userAction === 'dc-user-edit') {
        let upnModified=this.userservice.getObject("upn_value")!==this.dcUserForm.controls.upn.value;
        if (this.userData.roleId === 1 && upnModified) {
         this.validateUser(this.dcUserForm.controls.upn.value);
        } else {
          this.saveUserData();
        }
      }
      else {
        this.saveProfile();
      }

  }

  saveUserData() {
    let userData = new UserData();
    userData.sequenceNumber = this.dcUserForm.controls.sequenceNumber.value;
    userData.firstName = this.dcUserForm.controls.firstName.value;
    userData.lastName = this.dcUserForm.controls.lastName.value;
    userData.intials = this.dcUserForm.controls.intials.value;
    userData.license = this.dcUserForm.controls.license.value;
    userData.upn = this.dcUserForm.controls.upn.value;
    userData.storeNumber = [];
    userData.dcNumber = [];
    userData.dcNumber.push(this.dcUserForm.controls.dcLocation.value);
    userData.province = this.dcUserForm.controls.province.value;

    userData.roleId = (this.dcUserForm.controls.roleId.value);
    userData.language = this.dcUserForm.controls.language.value;
    userData.userStatus = this.dcUserForm.controls.userStatus.value ? 'Y' : 'N';

    this.userservice.saveUser(userData).subscribe(data => {
      this.backToSummary();
    }, (error: HttpErrorResponse) => {
      let dialogData = {
        title: this.userData.language === 'EN' ? 'Failed to Save' : 'L’enregistrement a èchoué',
       message: (error && error.error && error.status===409)
         ? (this.userData.language === 'EN' ? error.error.message : "Ce nom d’utilisateur existe déjà. Les comptes d'utilisateurs en double ne peuvent pas être créés") 
         :(this.userData.language === 'EN'?"Failed to save user data.":'L’enregistrement a èchoué') // need to translet to FR
        ,

      }
      this.dialog.open(DcnErrorComponent, {
        data: dialogData, panelClass: 'my-class'
      });
    })
  }

  saveProfile() {
    let nctmAccess=this.userData.nctmAccess;
    let userData = new UserData();
    userData.sequenceNumber = this.dcUserForm.controls.sequenceNumber.value;
    userData.license = this.dcUserForm.controls.license.value;
    userData.language = this.dcUserForm.controls.language.value;
    userData.firstName = this.dcUserForm.controls.firstName.value;
    userData.lastName = this.dcUserForm.controls.lastName.value;

    this.userservice.saveProfile(userData).subscribe(data => {

      this.userservice.getLoginUserData().subscribe(data => {
        this.translate.use(userData.language.toLowerCase());
        this.user = new UsersDataResponse()
        this.user = data;
        this.userData = data.userData
        this.userData.nctmAccess=nctmAccess;
        this.userservice.setCurrentUser(this.user);
        let dialogData = {
          title: this.userData.language === "EN" ? 'Success' : "Succès",
          message: this.userData.language === "EN" ? 'Sucessfully Saved' : "Enregistré avec succès",
          buttonCancel: false,


        }
        this.dialog.open(ApproveDialogComponent, {
          data: dialogData, panelClass: 'my-class',


        });
      })
    },
      (error: HttpErrorResponse) => {
        let dialogData = {
          title: this.userData.language === 'EN' ? 'Failed to Save' : 'L’enregistrement a èchoué',
          message: (error && error.error) ? error.error.message : "Failed to save user data."
          ,

        }
        this.dialog.open(ApproveDialogComponent, {
          data: dialogData, panelClass: 'my-class'
        })
      })




  }

  backToSummary() {
    if (this.userAction === 'dc-user-edit') {
      this.router.navigate(['/dcn-esign/administration/dc-users', this.dcNumber]);
    } else if (this.userAction === 'dc-user-add') {
      this.router.navigate(['/dcn-esign/administration/dc-users', this.dcUserForm.controls.dcLocation.value]);
    }
    
  }

  exitProfile() {
    this.router.navigate(['/dcn-esign/']);
  }
  valid = false;
  isLoading = true;
  message = "";
  validateUser(user) {
    let valid = false;
    const loginRequest = {
      scopes: ["user.read"],
      loginHint: this.userData.upn
      
    }

 
    this.graphService.getUserProfile(user).then(user => {
      this.saveUserData();
      valid = true;
    },

      (error) => {
        console.log(error.code)
       
        let dialogData = {
          title: this.userData.language === "EN" ? 'User Not Found' : "Utilisateur non trouvé",
          message: this.userData.language === "EN" ? "User not found in LCL Network." : "L'utilisateur n'a pas été trouvé dans le réseau LCL",

        }
        this.dialog.open(ApproveDialogComponent, {
          data: dialogData, panelClass: 'my-class'
        });
       
      })

  }




}
